import type { Template } from "@/types";

export const PO_06_H4_V2: Template[] = [
    {
        id: "po-06-h4v2-01",
        name: "PO 01 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 67, y: 178, width: 582, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 620, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 620, width: 189, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 461, y: 620, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 748, y: 250, width: 279, height: 416, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1035, y: 250, width: 279, height: 416, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h4v2-02",
        name: "PO 02 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 67, y: 175, width: 582, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 67, y: 555, width: 287, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 362, y: 555, width: 287, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 830, y: 175, width: 389, height: 264, rotation: 0, imageRotation: 0 },
            { id: "5", x: 830, y: 447, width: 191, height: 294, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1029, y: 447, width: 190, height: 294, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-03",
        name: "PO 03 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 91, y: 177, width: 234, height: 355, rotation: 0, imageRotation: 0 },
            { id: "2", x: 332, y: 177, width: 264, height: 173, rotation: 0, imageRotation: 0 },
            { id: "3", x: 332, y: 358, width: 264, height: 173, rotation: 0, imageRotation: 0 },
            { id: "4", x: 91, y: 539, width: 138, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 236, y: 539, width: 362, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 751, y: 272, width: 559, height: 373, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h4v2-04",
        name: "PO 04 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 59, y: 274, width: 569, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 743, y: 176, width: 287, height: 434, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1038, y: 176, width: 286, height: 434, rotation: 0, imageRotation: 0 },
            { id: "4", x: 743, y: 618, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 939, y: 618, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1135, y: 618, width: 189, height: 123, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-05",
        name: "PO 05 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 62, y: 186, width: 362, height: 545, rotation: 0, imageRotation: 0 },
            { id: "2", x: 432, y: 186, width: 202, height: 130, rotation: 0, imageRotation: 0 },
            { id: "3", x: 432, y: 324, width: 202, height: 130, rotation: 0, imageRotation: 0 },
            { id: "4", x: 432, y: 462, width: 202, height: 268, rotation: 0, imageRotation: 0 },
            { id: "5", x: 826, y: 186, width: 409, height: 268, rotation: 0, imageRotation: 0 },
            { id: "6", x: 826, y: 462, width: 409, height: 268, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-06",
        name: "PO 06 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 59, y: 273, width: 252, height: 371, rotation: 0, imageRotation: 0 },
            { id: "2", x: 318, y: 273, width: 178, height: 119, rotation: 0, imageRotation: 0 },
            { id: "3", x: 318, y: 400, width: 178, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 318, y: 526, width: 178, height: 118, rotation: 0, imageRotation: 0 },
            { id: "5", x: 503, y: 273, width: 252, height: 371, rotation: 0, imageRotation: 0 },
            { id: "6", x: 762, y: 273, width: 555, height: 371, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h4v2-07",
        name: "PO 07 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 70, y: 176, width: 747, height: 565, rotation: 0, imageRotation: 0 },
            { id: "2", x: 825, y: 176, width: 193, height: 279, rotation: 0, imageRotation: 0 },
            { id: "3", x: 825, y: 463, width: 193, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1026, y: 176, width: 278, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1026, y: 367, width: 278, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1026, y: 558, width: 278, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-08",
        name: "PO 08 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 214, width: 355, height: 240, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 462, width: 355, height: 240, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 214, width: 354, height: 240, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 462, width: 354, height: 240, rotation: 0, imageRotation: 0 },
            { id: "5", x: 725, y: 214, width: 321, height: 488, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1054, y: 214, width: 320, height: 488, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h4v2-09",
        name: "PO 09 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 70, y: 110, width: 241, height: 344, rotation: 0, imageRotation: 0 },
            { id: "2", x: 319, y: 110, width: 490, height: 344, rotation: 0, imageRotation: 0 },
            { id: "3", x: 817, y: 110, width: 488, height: 344, rotation: 0, imageRotation: 0 },
            { id: "4", x: 70, y: 462, width: 490, height: 344, rotation: 0, imageRotation: 0 },
            { id: "5", x: 568, y: 462, width: 489, height: 344, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1065, y: 462, width: 240, height: 344, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h4v2-10",
        name: "PO 10 - H4V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h4_v2_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 65, y: 145, width: 467, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 462, width: 467, height: 308, rotation: 0, imageRotation: 0 },
            { id: "3", x: 540, y: 145, width: 344, height: 507, rotation: 0, imageRotation: 0 },
            { id: "4", x: 540, y: 660, width: 168, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 716, y: 660, width: 168, height: 110, rotation: 0, imageRotation: 0 },
            { id: "6", x: 892, y: 145, width: 416, height: 625, rotation: 0, imageRotation: 0 }
        ],
    },
];

